<div class="app-layout-container">
  <app-skip-link></app-skip-link>
  <div [ngClass]="{
    'shift-content': showSkipLink,
    'paid-theme': isPaidServiceContext,
    'epak-theme': !isPaidServiceContext
  }">
    <app-browser-translation-banner></app-browser-translation-banner>
    <app-system-notifications></app-system-notifications>
    <app-platform-header
      [mode]="isBeforeLoginRoute ? 'beforeLogin' : 'afterLogin'">
    </app-platform-header>
    @if (!isBeforeLoginRoute) {
      @if (!isMobile) {
        <div class="app-layout-desktop">
          <div class="app-layout-with-sidebar">
            <app-side-nav></app-side-nav>
            <div class="app-layout-main">
              <app-fab-button></app-fab-button>
              <div id="main-content" tabindex="-1">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="app-layout-mobile-wrapper">
          <app-fab-button></app-fab-button>
          <div class="app-layout-mobile-content">
            <div id="main-content" tabindex="-1" class="app-layout-main-content-with-bottom-nav app-mobile-body">
              <router-outlet></router-outlet>
            </div>
          </div>
          <app-bottom-nav></app-bottom-nav>
        </div>
      }
    } @else {
      <app-fab-button></app-fab-button>
      <div id="main-content" tabindex="-1">
        <router-outlet></router-outlet>
      </div>
    }
    @if (showFooter) {
      <app-footer></app-footer>
    }
  </div>
</div>
